/* Dyese Protect — interactions custom homepage V3 */
(function () {
  'use strict';

  function rootsIn(scope, selector) {
    var roots = [];
    if (scope && scope.matches && scope.matches(selector)) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      Array.prototype.push.apply(roots, scope.querySelectorAll(selector));
    }
    return roots;
  }

  function initWelcome(scope) {
    rootsIn(scope, '[data-dp-code]').forEach(function (button) {
      if (button.dataset.bound === '1') return;
      button.dataset.bound = '1';
      button.addEventListener('click', function () {
        var code = button.dataset.dpCode;
        var done = function () {
          button.textContent = 'Code copié ✓';
          window.setTimeout(function () { button.textContent = code + ' · Copier'; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      });
    });
  }

  function initChoice(scope) {
    rootsIn(scope, '.dp-choice').forEach(function (root) {
      if (root.dataset.dpBound === '1') return;
      root.dataset.dpBound = '1';

      var data = {
        ts: {
          img: 'https://dyeseprotect.shop/cdn/shop/files/filtre_ts3_raccord_9e1f73fd-de01-43bb-801e-b287da196622.png?v=1778179174&width=600',
          alt: 'Filtre robinet Dyese TS',
          name: 'Gamme filtre robinet TS',
          tag: "Une filtration terminale directement au point d'usage.",
          facts: [['0,2 µm','Membrane à fibres creuses'],['1 · 3 · 4 mois','Trois durées au choix'],['M24 / M22','Raccord double selon configuration'],['Point d’usage','Solution fixe au robinet']],
          cta: 'Voir la gamme TS →',
          href: '/collections/filtre-robinet',
          note: "Les durées maximales varient selon le modèle, la qualité de l'eau et les conditions d'utilisation."
        },
        bofi: {
          img: 'https://dyeseprotect.shop/cdn/shop/files/Gourde_bofi_filtrante_dyese.png?v=1777564438&width=600',
          alt: 'Gourde filtrante BOFI Dyese',
          name: 'Gourde filtrante BOFI',
          tag: 'Une solution nomade en inox avec média filtrant type Ahlstrom et charbon actif.',
          facts: [['Jusqu’à 99,999 %','E. coli selon essais SGS'],['Jusqu’à 300 L','Capacité indicative par filtre'],['740 ml','Format inox isotherme'],['Nomade','À la maison ou en déplacement']],
          cta: 'Découvrir BOFI →',
          href: '/collections/gourde-filtrante',
          note: "Les valeurs annoncées correspondent aux essais disponibles. La capacité réelle dépend de l'eau et des conditions d'utilisation."
        }
      };

      function render(key) {
        var item = data[key];
        if (!item) return;
        var image = root.querySelector('[data-dp-img]');
        image.src = item.img;
        image.alt = item.alt;
        root.querySelector('[data-dp-name]').textContent = item.name;
        root.querySelector('[data-dp-tag]').textContent = item.tag;
        root.querySelector('[data-dp-facts]').innerHTML = item.facts.map(function (fact) {
          return '<div class="dp-choice__fact"><b>' + fact[0] + '</b><span>' + fact[1] + '</span></div>';
        }).join('');
        var cta = root.querySelector('[data-dp-cta]');
        cta.textContent = item.cta;
        cta.href = item.href;
        root.querySelector('[data-dp-note]').textContent = item.note;
        root.querySelectorAll('[data-dp-choice]').forEach(function (button) {
          var active = button.dataset.dpChoice === key;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      root.querySelectorAll('[data-dp-choice]').forEach(function (button) {
        button.addEventListener('click', function () { render(button.dataset.dpChoice); });
      });
      render('ts');
    });
  }

  function init(scope) {
    initWelcome(scope);
    initChoice(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
